<template>
  <div class="usage-menu_block">
    <div class="left">
      <div><a class="underline-little-huge_label" @click="scrollToHash('service')">サービス概要</a></div>
      <div><a class="underline-little-huge_label" @click="scrollToHash('client')">クライアントの発注の流れ</a></div>
      <div><a class="underline-little-huge_label" @click="scrollToHash('operator')">オペレーターの受注の流れ</a></div>
    </div>
    <div class="right">
      <div><a class="underline-little-huge_label" @click="scrollToHash('score')">評価について</a></div>
    </div>
  </div>
</template>

<script>

  import scroll from "@/assets/js/functions/_core/scroll";

  export default {
    name: "UsageMenuBlock",

    mixins: [scroll],
  }
</script>

<style lang="scss" scoped>
  .usage-menu_block {
    @include double_columns($left: 50%, $right: 50%);

    > .right, > .left {
      > div {
        margin-bottom: 2rem;
        width: 80%;
      }
    }
  }
</style>